import CardAnalise from '@componentsNew/Analises/CardAnalises';
import ListaAnalises from '../../ListaAnalises';

export default function AnaliseSeoTextual({ analise, carregando, erro }) {
  return (
    <CardAnalise
      nota={analise?.filter(r => r.otimizado == true).length / analise?.length}
      titulo="Análise de SEO"
      subTitulo="Critérios textuais"
      textoButton={true}
    >
      <ListaAnalises
        resultadoAnalises={analise}
        carregando={carregando}
        erro={erro}
        tipo={'textual'}
      />
    </CardAnalise>
  );
}
